// 自定义的图形对象文件
import * as THREE from "three";

// 创建二维点对象
export const create2dAnyPoint = (points) => {
  // 创建圆形的几何体
  let geometry = new THREE.CircleGeometry(32, 32);

  // 创建圆形的材质
  let material = new THREE.MeshBasicMaterial({ color: 0xffffff });

  // 创建圆形的网格对象
  let tPointObj = new THREE.Mesh(geometry, material);

  tPointObj.position.set(points[0], points[1], 0);

  return tPointObj;
};

// 创建三维点对象
export const create3dAnyPoint = (points) => {
  // 创建圆形的几何体
  let geometry = new THREE.CircleGeometry(100, 32);

  // 创建圆形的材质
  let material = new THREE.MeshBasicMaterial({ color: 0xff0000 });

  // 创建圆形的网格对象
  let tPointObj = new THREE.Mesh(geometry, material);

  tPointObj.position.set(points[0], points[1], points[2]);

  return tPointObj;
};

// 创建的二维直线对象
export const create2dAnyLine = (points) => {
  let data = points.map((item) => {
    let obj = item.clone();
    obj.z = 0;
    return obj;
  });
  // 创建材质
  const material = new THREE.LineBasicMaterial({ color: 0xffffff });
  // 创建直线的几何体
  const geometry = new THREE.BufferGeometry().setFromPoints(data);
  // 创建直线对象
  const tPointObj = new THREE.Line(geometry, material);
  // tPointObj.scale.set(0.001, 0.001, 0.001)
  return tPointObj;
};

//线粗细切换
// export const create2dAnyLine = (points) => {
//   const sharedMaterial = new THREE.LineBasicMaterial({ color: 0xffffff });

//   let data = points.map((item) => {
//     let obj = item.clone();
//     obj.z = 0;
//     return obj;
//   });

//   // 创建细线
//   const geometry = new THREE.BufferGeometry().setFromPoints(data);
//   const line = new THREE.Line(geometry, sharedMaterial);

//   // 创建粗线
//   const path = new THREE.CatmullRomCurve3(data);
//   const tubeGeometry = new THREE.TubeGeometry(path, data.length, 10, 8, false);
//   const thickLine = new THREE.Mesh(tubeGeometry, sharedMaterial);

//   // 创建切换的对象
//   const tPointObj = new THREE.Object3D();
//   tPointObj.add(line);
//   tPointObj.add(thickLine);
//   tPointObj.line = line;
//   tPointObj.thickLine = thickLine;
//   tPointObj.material = line.material;
//   tPointObj.linetype = false; // true表示显示细线，false表示显示粗线

//   // 设置显示的线
//   tPointObj.updateLineType = function () {
//     this.line.visible = this.linetype;
//     this.thickLine.visible = !this.linetype;
//   };

//   // 初始化线的显示
//   tPointObj.updateLineType();

//   return tPointObj;
// };

// 创建的三维直线对象
export const create3dAnyLine = (points) => {
  // 创建材质
  const material = new THREE.LineBasicMaterial({ color: 0xffffff });
  const geometry = new THREE.BufferGeometry().setFromPoints(points);
  // 稍微缩小一点 解决Z-fighting冲突
  geometry.scale(0.99, 0.99, 0.99);
  // 创建直线对象
  const tPointObj = new THREE.Line(geometry, material);
  // tPointObj.scale.set(0.001, 0.001, 0.001)
  return tPointObj;
};

// 创建圆对象
export const createAnyCircle = (points, radius) => {
  // 创建圆形的几何体
  let geometry = new THREE.CircleGeometry(radius ? radius : 500, 64);
  geometry.vertices.shift();
  // 创建圆形的材质
  let material = new THREE.LineBasicMaterial({ color: 0xffffff });
  // 创建圆形的网格对象
  let tPointObj = new THREE.LineLoop(geometry, material);
  tPointObj.position.set(points[0]["x"], points[0]["y"], 0);
  return tPointObj;
};

export const createAnyText = (pt, text, font) => {
  const geometry = new THREE.TextGeometry(text, {
    font: font,
    size: 300,
    height: 0.005,
  });

  const material = new THREE.MeshBasicMaterial({ color: 0xffffff });
  const mesh = new THREE.Mesh(geometry, material);

  mesh.position.set(pt.x, pt.y, pt.z);

  return mesh;
};
